'use client'

import {usePortfolioMaterial}             from '@/app/(frontend)/[lang]/(with-chrome)/portfolio/usePortfolioMaterial'
import {usePageContext}                   from '@/context/PageContext'
import {Plane}                            from '@react-three/drei'
import React, {Fragment, useMemo, useRef} from 'react'
import * as THREE                         from 'three'

const PortfolioCanvasElement = ({
	project,
	progress,
	inView,
}) => {
	const planeRef     = useRef(null)
	const subdivisions = project.distorted ? 4 : 0

	const ratio = useMemo(() => {
		return project.media.width / project.media.height
	}, [project.media])

	const positionNormalized = useMemo(() => new THREE.Vector3(project.position.x, project.position.y, project.position.z), [project.position])

	const {
		      key,
		      positionNode,
		      colorNode,
	      } = usePortfolioMaterial({
		project,
		progress,
		inView,
	})

	return <Plane
		ref={planeRef}
		args={[16 / 8, 16 / 8 / ratio, 2 ** subdivisions, 2 ** subdivisions]}
		key={project.media}
		position={positionNormalized}
	>
		<meshBasicNodeMaterial
			key={key}
			positionNode={positionNode}
			colorNode={colorNode}
			transparent={true}
		/>
	</Plane>
}

const CanvasContent = ({
	diveIn,
	progress,
	inView,
}) => {
	const {isMobile} = usePageContext()

	const items = useMemo(() => {
		const items = isMobile ? diveIn.items.filter(item => item.position.z <= 0) : diveIn.items

		const centerPosition = new THREE.Vector3(0, 0, 0)
		items.forEach(item => item.isCenterElement = centerPosition.equals(new THREE.Vector3(item.position.x, item.position.y, item.position.z)))

		return items
	}, [diveIn.items, isMobile])

	return (<>
		{items.map(item => <PortfolioCanvasElement
			key={item.id}
			project={{
				...item,
				media: {
					...item.media,
					url: `/_next/image?url=${encodeURIComponent(item.media?.url)}&w=${item.distorted ? 1440 : 440}&q=75`,
				},
			}}
			progress={progress}
			inView={inView}
		/>)}
	</>)
}

export default CanvasContent
